export const getters = {
  systemFileopeneddates: state => state.fileopeneddates,
  systemFileopeneddate: state => state.data
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/reports/getters.js